import { Row } from "@/common/css";
import Icon from "@/common/ui/Image";
import { LightText2 } from "@/common/ui/Text";
import { AllowedFileType, FILE_EXTENSION_ICON_MAP } from "@/utils/helper/fileUploadValidation";
import React from "react";

interface FileNameWithIconProps {
  name: string;
}

const FileNameWithIcon: React.FC<FileNameWithIconProps> = ({ name }) => {
  const fileType: AllowedFileType | undefined = name?.split(".").pop() as AllowedFileType;
  return (
    <Row className=" gap-x-2">
      {fileType && <Icon src={FILE_EXTENSION_ICON_MAP[fileType]} alt="" className=" size-6" />}
      <LightText2 text={name} className=" line-clamp-1" />
    </Row>
  );
};

export default FileNameWithIcon;
